export default __webpack_public_path__ + "4497e782111f4fe697beb25a141d28e5.svg";